import { ReactNode } from 'react';

import { checkAxiosError } from './axios';
import { isServer } from './env-helper';
import { getErrorMessage } from './error';

export interface AlertProps {
  warn?: boolean;
  title?: ReactNode;
  message: unknown;
  onConfirm?: () => void;
  confirmText?: string;
  onClose?: () => void;
  closeText?: string;
  withClose?: boolean;
}

export const alertListeners = new Set<(alert: AlertProps | null) => void>();

export const alert = {
  show(props: AlertProps) {
    alertListeners.forEach((listener) => listener(props));
  },
  clear() {
    alertListeners.forEach((listener) => listener(null));
  },
  error(err: unknown, options: { onlyAxiosError?: boolean } = {}) {
    if (options.onlyAxiosError && !checkAxiosError(err)) return;
    if (!isServer && window.location.pathname === '/maintenance') {
      this.clear();
      return;
    }
    const message = getErrorMessage(err);
    if (message) this.show({ message });
  },
};
